import { LotteryConfigModel } from "../models/lottery-configuration-model";
import { Lottery } from "../../../models/lottery";

export const miniRentaConfig: LotteryConfigModel = {
    lottery: Lottery.miniRenta,
    boardCount: 16,
    boardCountKasa: 7,
    primaryBoardSize: 7,
    defaultStake: 0,
    defaultStakeKasa: 1000,
    basePrice: 10,
    primaryNumbers: 24,
    boardLabel: "Sloupec",
    hasDurationComponent: true,
    hasDrawOptions: false,
    hasMultidrawNotification: true,
    hasAllOrOneMultidrawOptions: true,
    hasSubscription: true,
    isDrawnEveryDay: true,
    durationTitle: "Mini renta se losuje každý den.",
    durationTitleShort: "Mini renta se hraje pravidelně 1x denně.",
    maxDuration: 91,
    // Is filled from wager duration for this lottery
    multidrawDurationOptions: [],
    inlineBoardsMaxCount: 4,
    hasCalculatedJackpot: false,
};
